import React from 'react';
import { makeStyles, CircularProgress } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  spinner: {
    height: '22px',
    width: '22px',
  },
}));

interface ButtonSpinnerProps {
  isLoading?: boolean;
  children?: React.ReactNode;
  progress?: number;
}

const ButtonSpinner: React.FC<ButtonSpinnerProps> = ({
  isLoading,
  children,
  progress,
}) => {
  const classes = useStyles();
  return (
    <>
      {isLoading ? (
        <CircularProgress
          variant={
            progress !== undefined && progress >= 0
              ? 'determinate'
              : 'indeterminate'
          }
          value={progress}
          size="22"
          className={classes.spinner}
        />
      ) : (
        children
      )}
    </>
  );
};

export default ButtonSpinner;
